import React from 'react';
import styles from './onboarding.module.css';

export default function Rhythm({ name }) {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '3rem' }}>
                {/* <h1 className={styles.onboardingGreeting}>
					Missing is human. <br/>Returning is transformative.
				</h1> */}
                <h1 className={styles.onboardingGreeting}>
                    Returning matters <span style={{ fontWeight: 200 }}>way</span> more than never missing
                </h1>
                <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '1.5rem' }}>
                    {/* <p className={styles.para}>
						Even if you miss a day {name},<br />your next feeling shows the way forward.
					</p> */}
                    <p className={styles.para}>
                        Even if you miss a day {name},<br /> just follow your next feeling forward.
                    </p>
                    <p className={styles.para}>
                        Because there are <strong>no wrong feelings</strong><br /> and <strong>no wasted flows.</strong>
                    </p>
                </div>
            </div>
        </>

        // <>
        // 	<div></div> {/* Empty div for centering */}
        // 	<div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '2rem' }}>
        // 		<h1 className={styles.onboardingGreeting}>
        // 			The rhythm is what matters, {name}
        // 		</h1>
        // 		<div style={{ textAlign: "center" }}>
        // 			<p className={styles.para}>
        // 				Even if you miss a beat,<br/> let your next feeling show the way.
        // 			</p>
        // 		</div>
        // 		<p className={styles.para}>
        // 				Because there're <b>no wrong feelings</b> and <b>no wasted flows.</b>
        // 			</p>
        // 	</div>
        // </>
    );
}
